/* @flow */
import type { Action } from "../action";
import type { DepositBonusInserted } from "../CommonTypes";

type State = DepositBonusInserted | null;

function receiveSocketMessage(state, payload) {
  switch (payload.op) {
    case "deposit-bonus-inserted":
      return payload;
    default:
      return state;
  }
}

function referralBonus(state?: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    case "DISMISS_REFERRAL_BONUS":
      return null;
    default:
      return state;
  }
}

export default referralBonus;



// WEBPACK FOOTER //
// ./src/redux/reducer/referralBonus.js